import { MODAL_SIZE } from '../../App.config';
import * as actionTypes from '../actionTypes';

export function openSetModal(children, size, disableClose) {
  return {
    type: actionTypes.OPEN_SET_MODAL,
    'children': children,
    size,
    disableClose
  }
}
export function openModal() {
  return {
    type: actionTypes.OPEN_MODAL
  }
}
export function closeModal() {
  return {
    type: actionTypes.CLOSE_MODAL
  }
}
export function closeRemoveModal() {
  return {
    type: actionTypes.CLOSE_REMOVE_MODAL
  }
}


